export const tMenuData = [
  {
    tabName:"런스타",
    tabCode:"cont1",
  },
  {
    tabName:"척 70",
    tabCode:"cont2",
  },
  {
    tabName:"원스타",
    tabCode:"cont3",
  },
  {
    tabName:"플랫폼",
    tabCode:"cont4",
  },
];